import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { Figure as AvatarFigure } from "scmp-app/components/author/author-avatar/styles";
import { AvatarContainer } from "scmp-app/components/content/content-author-image/styles";
import { AuthorEntityLink } from "scmp-app/components/content/content-author/styles";
import { H1Container, H2Container } from "scmp-app/components/content/content-headline/styles";
import { EntityLink } from "scmp-app/components/entity-link";

import ImagePlusFlag from "./img-plus.svg";

export const StyledImagePlusFlag = styled(ImagePlusFlag)`
  margin-block-end: 12px;
`;

export const LiveTagContainer = styled.div`
  &:not(:empty):not(:last-child) {
    margin-block-end: 12px;
  }
`;

export const Header = styled.div`
  grid-area: header;

  display: inline-block;

  margin-block-end: 12px;

  ${H1Container}, ${H2Container} {
    font-weight: 700;
    font-size: 16px;
    font-family: ${fontRoboto};
    line-height: 21px;
    text-overflow: ellipsis;

    ${props => props.theme.breakpoints.up("desktop")} {
      font-weight: 700;
      font-size: 20px;
      font-family: ${fontRoboto};
      line-height: 26px;
    }
  }
`;

export const Cover = styled.div`
  grid-area: cover;

  inline-size: 60px;
  block-size: 60px;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 80px;
    block-size: 80px;
  }
`;

export const Authors = styled.div`
  grid-area: authors;

  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  margin-block-end: 12px;

  :empty {
    margin-block-end: 0;
  }

  ${AvatarContainer} {
    margin: 0;
    margin-inline-end: 6px;

    :empty {
      margin-inline-end: 0;
    }
  }

  ${AvatarFigure} {
    inline-size: 20px;
    block-size: 20px;

    border-width: 2px;
  }

  ${AuthorEntityLink} {
    color: #001246;
    font-weight: 700;
    font-size: 12px;
    font-family: ${fontRoboto};
  }
`;

export const Summary = styled.div`
  grid-area: summary;

  display: inline-block;
  display: -webkit-box;

  margin-block-end: 12px;

  color: #333333;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 18px;
  text-overflow: ellipsis;

  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;

  :empty {
    margin-block-end: 0;
  }
`;

export const Footer = styled.div`
  grid-area: footer;

  color: #999999;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 21px;

  time {
    font-size: 12px;
  }
`;

export const PrintHeadline = styled.div`
  grid-area: print-headline;

  margin-block-start: 12px;

  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;

  &:empty {
    display: none;
  }
`;

export const Container = styled.div``;

export const StyledEntityLink = styled(EntityLink)`
  display: grid;
  grid:
    "header . cover" min-content
    "authors . cover" min-content
    "summary . cover" min-content
    "footer . cover" min-content
    "print-headline . cover" min-content
    ". . cover" min-content
    / 1fr 12px 60px;

  inline-size: 100%;
  padding-block: 16px;
  box-sizing: border-box;

  cursor: pointer;

  :not(:has(${AvatarContainer}:hover)):not(:has(${AuthorEntityLink}:hover)):hover {
    ${Header} {
      color: #2c4692;
    }
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    grid:
      "header . cover" min-content
      "authors . cover" min-content
      "summary . cover" min-content
      "footer . cover" min-content
      "print-headline . cover" min-content
      ". . cover" min-content
      / 1fr 20px 80px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block: 20px;
  }
`;
